<template>
  <!-- APP 应用  -->
  <div id="app" v-show="app_visible">
    <!-- 壳组件  core -->
    <div class="core" id="CORE-SWF" onselectstart="var t=event.target;return !!(t&&t.closest&&(t.closest('input,textarea')!==null||t.isContentEditable))">
      <!-- 标签区组件  tab-core -->
      <!-- <div class="tab tabs_hook" v-if="tab_visible">
        <div :class="item.class"
            v-for="item, index in tabs"
            @click="handleChangeTab(index)">
            {{item.title}}
          <span class="el-icon-close" style="margin-left:10px;" v-if="item.tab_type != '0'" @click.stop="handleCloseTab(index)"></span>
        </div>
      </div> -->
      <!-- 路由切换 router-view -->
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
      <div class="timeline_toolbar">
        <div class="item" v-for="item, index in toolbar_list" @click="toolbarOpe(item)">
          <i :class="'icon-' + item[0]"></i>
        </div>
        <div class="jiantou"></div>
      </div>
      <div class="export" v-if="export_status">
        <export></export>
      </div>
      <!-- 分享启用弹窗 -->
      <el-dialog title="分享" class="dialog" :visible.sync="share_show_start" size="tiny">
        <el-form class="body">
          <el-form-item label='分享周期'>
              <el-col :span="12">
                  <el-select v-model="share_select_time" placeholder="请选择">
                      <el-option v-for="item in share_select_times" :key="item.key" :label="item.label" :value="item.value"></el-option>
                  </el-select>
              </el-col>
          </el-form-item>
          <el-form-item>
              {{"有效期至     " + this.share_select_deadline}}
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" :disabled="this.share_select_time == ''" @click="handleStartShare()">{{"启用"}}</el-button>
          <!-- <div style="padding-top: 20px;">
              ---------------------------------------------------
          </div>
          <div style="padding-top: 12px; font-size:16px;">
              H5动画体验版
          </div>
          <div style="height: 16px;"></div>
          <div id='qrcode'></div> -->
        </div>
      </el-dialog>
      <!-- 分享关闭弹窗 -->
      <el-dialog title="分享" class="dialog" :visible.sync="share_show_stop" size="tiny">
        <el-form class="body">
          <el-form-item>
            {{"有效期至  " + this.timestamp(this.share_deadline*1000)}}<font color='#ff0000'>   (已启用)</font>
          </el-form-item>
          <el-form-item label="播放链接">
              <el-row :gutter="4">
                  <el-col :span="14">
                      <el-input style="height=22px;" :disabled="true" resize="none" :placeholder="this.share_url"></el-input>
                  </el-col>
                  <el-col :span="1">
                      <el-button id="copy_btn" size='mini' data-clipboard-action="copy"
                        data-clipboard-target="#clipboard" @click="handleShareCopy()">复制</el-button>
                  </el-col>
              </el-row>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleStopShare()">{{"停用"}}</el-button>
        </div>
      </el-dialog>
      <!-- 文字输入弹窗 -->
      <el-dialog :title="text_box_data.title" class="dialog" :visible.sync="text_box_show" size="tiny" >
        <el-form class="body">
          <el-form-item :label="text_box_data.text">
              <el-input :placeholder="text_box_data.value" v-model="text_box_data.value" @keyup.enter.native="handleTextBox()">
              </el-input>
              <!-- 添加这个input 是为了 el-input @keyup.enter.native="handleTextBox()" 方法可以触发 -->
              <input style="width:0px;height:0px;border: 0px solid white;">
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleTextBox()">{{text_box_data.button}}</el-button>
        </div>
      </el-dialog>
      <!-- 弹窗组件 -->
      <el-dialog :title="alertData.title" class="dialog" :visible.sync="dialog_create_action_visible" size="tiny">
        <el-form class="body">
          <el-form-item>
            {{alertData.text}}
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleAlertButton(alertData.id, (alertData.buttonsList ? alertData.buttonsList[0].id : ''))">{{alertData.buttonsList ? alertData.buttonsList[0].text : ''}}</el-button>
          <el-button type="primary" v-if="alertData.buttonsList && alertData.buttonsList.length > 1" @click="handleAlertButton(alertData.id, (alertData.buttonsList ? alertData.buttonsList[1].id : ''))">{{alertData.buttonsList ? alertData.buttonsList[1].text : ''}}</el-button>
        </div>
      </el-dialog>
      <!-- 动画被锁定的弹窗组件 @close="closeAnim()"-->
        <el-dialog title="提示" class="dialog dialog-delete" :visible.sync="dialog_lock_anim"  center>
            <span>{{dialog_lock_anim_msg}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeAnim()">退出编辑</el-button>
            </span>
        </el-dialog>
      <!-- 序列帧设置 -->
      <div class="pop_block" id="pop_block" v-show="pop_block_show" :style="{left: (pop_block_left + pop_block_originX) + 'px',top:(pop_block_originY + 36) + 'px'}">
        <div class="top" v-drag>
            <div class="title">序列帧设置</div>
            <div class="close" @click="pop_block_show = false">X</div>
        </div>
        <div class="content">
            <div class="rate" >
                <div class="name">帧速率: </div>
                <!-- <input class="rate_input" type="text" list="rate_list" v-model="rate_input_model" v-on:input="handleInputEditing('rate')">  &nbsp帧/秒 -->
                <select class="rate_select" v-model="rate_input_model" @change="handleRateSelectChange">
                    <option v-for="item in rate_input_list" :value ="item">{{item}}</option>
                </select> &nbsp帧/秒
                <div style="display:inline-block;position:absolute;margin-left:-5px;margin-top:-2px;width:130px;height:25px;line-height:25px;font-size:10px;-webkit-transform:scale(0.8);color:#959595;">每秒钟播放图片帧数</div>
            </div>
            <div class="loop">
                <div class="name">循环:</div>
                <el-radio-group v-model="loop_data" @change="handleChangeOption">
                    <div class="item"><el-radio :label="0">是</el-radio></div>
                    <div class="item"><el-radio :label="1">否</el-radio></div>
                </el-radio-group>
            </div>
            <div class="duration" >
                <div class="name">移动时长: </div>
                <input class="duration_input" type="text" v-model="duration_input_model" :class="{'disabled':duration_input_disabled}" :disabled="duration_input_disabled" v-on:input="handleInputEditing('duration')">  &nbsp秒
                <div style="display:inline-block;position:absolute;margin-left:-5px;margin-top:-2px;width:130px;height:25px;line-height:25px;font-size:10px;-webkit-transform:scale(0.8);color:#959595;">0表示不可移动</div>
            </div>
        </div>
      </div>

      <div class="clipboard" style="text-indent:-9999px;" id="clipboard"></div>
    </div>
  </div>
</template>
<script>
    // 通讯协议
    import Protocol from '@/common/scripts/protocol.js'
    // 公共方法
    import EUY from '@/common/scripts/euy'
    // 导出组件
    import Export from '@/components/Export/Export'

    import Clipboard from 'clipboard'
    export default {

        // 组件
        components: {
            Export
        },
        // 数据
        data () {
            return {
                dialog_create_action_visible: false,
                alertData: {title:"", text:"", modal:true, id:""},
                // 双击形象进入动作编辑模式（区别于 tab_type 存储值，避免污染标签状态）
                action_edit_mode: false,
                // -------------------------------------------------- [ 标签切换 ] --------------------------------------------------
                // 数据
                tabs: [{ tab_type: "0", url: "/homepage", title: "首页", id: "homepage", class: "active", proportion: ""}],
                tabs_index: '',
                tabs_status: '',
                timer_create: null,
                timer_change: null,
                timer_close: null,
                // -------------------------------------------------- [ 用户信息 ] --------------------------------------------------
                // 用户信息
                userinfo: {
                    nickname: '',
                    avatarInfo: '',
                    gid: '',
                },
                // -------------------------------------------------- [ 显示隐藏 ] --------------------------------------------------
                // 状态
                app_visible: true,
                tab_visible: true,
                // -------------------------------------------------- [ 本地缓存 ] --------------------------------------------------
                // 登录状态
                login_status: {
                    tokenId: '',
                    exkey: ''
                },
                toolbar_list: [],
                time: null,
                timeline_position_top: '',
                timeline_position_left: '',
                export_status:false,
                //分享
                share_id: '',
                share_title: "",
                share_orientation: "landscape",
                share_state: 0,
                share_url: '',
                share_deadline: '',
                share_show_start: false,
                share_show_stop: false,
                share_select_times: [
                    {key: 0, label: '3小时', value: '10800'},
                    {key: 1, label: '12小时', value: '43200'},
                    {key: 2, label: '1天', value: '86400'},
                    {key: 3, label: '3天', value: '259200'},
                    {key: 4, label: '7天', value: '604800'},
                ],
                share_select_time: '',
                qrcode: null,

                text_box_data: {},
                text_box_show: false,
                // 动画的心跳
                timer_anim_heartbeat:null,
                // tab
                tab_anim:'',
                // 动画被锁定
                dialog_lock_anim:false,
                //
                dialog_lock_anim_msg:'',
                // 动作编辑器选择动作弹出面板标记
                action_info_modlus_status:false,
                //鼠标滚轮侦听等待
                mouseWheelWaiting:false,
                // 重连次数
                heart_reconnect_count:0,
                token_heart_timer:'',
                // 序列帧
                pop_block_left:0,
                pop_block_originX:0,
                pop_block_originY:0,
                pop_block_show:false,
                loop_data:0,
                rate_input_model:'8',
                duration_input_model:'',
                pop_block_alias:'',
                duration_input_disabled:false,
                rate_input_list:['1','2','3','4','6','8','12','24'],
            }
        },
        directives:{
            drag(el){
                el.onmousedown = function(e){
                    let element = 'pop_block'
                    //获取鼠标点击处分别与div左边和上边的距离：鼠标位置-div位置
                    var divx = e.clientX - document.getElementById(element).offsetLeft;
                    var divy = e.clientY - document.getElementById(element).offsetTop;
                    // 获取当前浏览的宽高
                    let winHeight = window.innerHeight
                    let winWidth  = window.innerWidth
                    let moveWidth = document.getElementById(element).offsetWidth;
                    let moveHeight = document.getElementById(element).offsetHeight;
                    let maxX = winWidth - moveWidth
                    let maxY = winHeight - moveHeight
                    //包含在onmousedown里，表示点击后才移动，为防止鼠标移出div，使用document.onmousemove
                    document.onmousemove = function(e){
                        //获取移动后div的位置：鼠标位置-divx/divy
                        var left = e.clientX - divx;
                        var top = e.clientY - divy;
                        if(left<=0) left=0
                        if(left>=maxX) left = maxX
                        if(top<=0) top=0
                        if(top>=maxY) top = maxY
                        document.getElementById(element).style.left = left + 'px';
                        document.getElementById(element).style.top  = top  + 'px';
                    }
                    document.onmouseup = function(e){
                        document.onmousemove = null;
                        document.onmouseup = null;
                    }
                }
            }
        },

        computed: {
            share_select_deadline () {
                if(this.share_select_time == '') {
                    return "未启用";
                }else {
                    return this.timestamp((new Date()).getTime() + parseInt(this.share_select_time)*1000);
                }
            },
        },
        // 方法
        methods: {
            handleRateSelectChange(event){
                this.rate_input_model = event.target.value
                this.sendMessage_6_54()
            },

            handleChangeOption(value){
                this.duration_input_disabled = value == 1? true:false
                this.sendMessage_6_54()
            },
            handleInputEditing(type){
                this.sendMessage_6_54()
            },

            sendMessage_6_54(){
                let platform = this.$route.query.platform
                let loop = this.loop_data == 0 ? true:false
                console.log('sendMessage_6_54 ===> ' + loop + ' , '+this.pop_block_alias + ' , '+this.rate_input_model + ' , '+ this.duration_input_model)
                let core_message_6_54 = {
                    packageId: 0,
                    senderId: CORE,
                    senderName: CORE_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: MESSAGE_ID_CORE_MESSAGE_6_54,
                    protoBytesType: 'proto.com.proto.scene.MFramesSetting',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MFramesSetting(), {
                        setAlias: this.pop_block_alias,
                        setFramerate: this.rate_input_model,
                        setLoop: loop,
                        setDuration: this.duration_input_model,
                    })
                }
                // 发送消息
                Protocol.sender(platform, core_message_6_54)
            },

            // 时间戳转换
            timestamp(date) {
              return moment(parseInt(date)).format('YYYY-MM-DD  HH:mm')
            },
            // 保持动画心跳
            handleAnimHeartbeat() {
                let URL = process.env.HOST + '/api/storage/storage/resource/heartbeat'

                let tabs_store = EUY.GetStorage('tabs')
                let array = []
                if (tabs_store) {
                    if (tabs_store.length == 1) {
                        this.app_off_line_edit = false
                        return false
                    }
                    for (let i = 1; i < tabs_store.length; i++) {
                        if(tabs_store[i].tab_type == '2'){
                            if(tabs_store[i].id.substring(0,2) != '73'){
                                array.push(tabs_store[i].id)
                                break
                            }
                        }else{
                            array.push(tabs_store[i].id)
                            break
                        }
                    }
                }

                let token = this.login_status.tokenId

                if (token == '') return
                if (array.length == 0) return
                let params = 'id=' + array.toString()
                let headers = {
                    'Authorization': token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
                this.AJAX.post(URL, headers, params, {noAuthRedirect: true}).then((data)=>{
                    this.dialog_lock_anim = false
                    console.log('Heartbeat --------- success  ')
                }).catch((err)=>{
                    console.log('Heartbeat --------- error  ' + JSON.stringify(err))
                    if(err.code != undefined){
                        //  动画被锁定
                        this.dialog_lock_anim = true
                        this.dialog_lock_anim_msg = err.msg
                    }else {
                        this.$message({
                            message: err.msg||err.message,
                            type: 'error'
                        })
                    }
                })
            },
            // 关闭当前动画
            closeAnim(){
                this.dialog_lock_anim = false
                let platform = this.$route.query.platform
                let toolbar_1_30 = {
                    packageId: 0,
                    senderId: CORE,
                    senderName: CORE_NAME,
                    receiverId: CORE,
                    receiverName: CORE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: MESSAGE_ID_TOOLBAR_1_30,
                    protoBytesType: null,
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(platform, toolbar_1_30)
            },

            handleAnimEndEdit(){
                let URL = process.env.HOST + '/api/storage/storage/resource/end-edit'
                let currentTab = EUY.GetStorage("currentTab");
                let heartId = currentTab.id
                let token = this.login_status.tokenId
                // heartId 为homepage 或者以73开头 或者token为''都不心跳
                if (heartId.substring(0, 2) == '73' || token == '' || heartId == 'homepage'){
                    return
                }

                let params = 'id=' + heartId
                let headers = {
                    'Authorization': token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
                this.AJAX.post(URL, headers, params, {noAuthRedirect: true}).then((data)=>{}).catch((err)=>{})
            },

            handleAlertButton (id, buttonId)
            {
                this.dialog_create_action_visible = false
                let platform = this.$route.query.platform
                let core_step_1_10 = {
                    packageId: 0,
                    senderId: CORE,
                    senderName: CORE_NAME,
                    receiverId: this.sender,
                    receiverName: this.sender,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: MESSAGE_ID_CORE_STEP_1_10,
                    protoBytesType: 'proto.com.proto.s.MAlertBack',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MAlertBack(), {
                        setId: id,
                        setButtonid: buttonId
                    })
                }
                // 发送消息
                Protocol.sender(platform, core_step_1_10)
            },

            handleChangeTab (index)
            {
                let tab = this.tabs[index];
                this.tabs_status = 'change'
                let platform = this.$route.query.platform
                let core_scene_1_22 = {
                    packageId: 0,
                    senderId: CORE,
                    senderName: CORE_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: MESSAGE_ID_CORE_SCENE_1_22,
                    protoBytesType: 'proto.com.proto.s.MString',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MString(), {
                        setValue: tab.id,
                    })
                }
                this.timer_change = setTimeout(() => {
                    this.changeTab(tab.id)
                }, 500)
                // 发送消息
                Protocol.sender(platform, core_scene_1_22)
            },

            handleCloseTab (index)
            {
                let tab = this.tabs[index];
                this.tabs_status = 'close'
                let  platform = this.$route.query.platform
                let core_scene_1_22 = {
                    packageId: 0,
                    senderId: CORE,
                    senderName: CORE_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: MESSAGE_ID_CORE_SCENE_1_22,
                    protoBytesType: 'proto.com.proto.s.MString',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MString(), {
                        setValue: tab.id,
                    })
                }
                this.timer_close = setTimeout(() => {
                    this.closeTab(tab.id)
                }, 500)
                // 发送消息
                Protocol.sender(platform, core_scene_1_22)
            },

            createTab(tab)
            {
                EUY.SetStorage('currentTab', tab);
                let tabs_store = EUY.GetStorage('tabs');
                if (tabs_store) {
                    for (let i = 0; i < tabs_store.length; i++) {
                        tabs_store[i].class = ''
                        // 是否已经打开
                        if (tabs_store[i].id == tab.id) {
                            tabs_store[i].class = 'active'
                            EUY.SetStorage('tabs', tabs_store)
                            this.tabs = tabs_store
                            this.$router.push('/ui/' + tab.id)
                            return false
                        }
                    }
                    //如果打开新的动画则清空tab栈
                    if(tab.type == 1) {
                        tabs_store.length = 1;
                    }
                    tabs_store.push({
                        url: '/ui/' + tab.id,
                        tab_type: tab.type,
                        title: tab.title,
                        id: tab.id,
                        proportion: tab.screentype,
                        team_id: tab.teamid,
                        team_name: tab.teamname,
                        folder: tab.folder,
                        data: tab.data,
                        class: 'active'
                    })
                    EUY.SetStorage('tabs', tabs_store)
                    this.tabs = tabs_store
                }
                this.timer_create = setTimeout(() => {
                    this.changeTab(tab.id)
                }, 500);
            },

            changeTab(id)
            {
                this.tabs_status = 'init'
                let tabs_current_id = id
                let tabs_store = EUY.GetStorage('tabs')
                if (tabs_store) {
                    let index = 0
                    for (let i = 0; i < tabs_store.length; i++) {
                        tabs_store[i].class = ''
                        if (tabs_store[i].id == tabs_current_id) {
                            index = i
                            break;
                        }
                    }
                    tabs_store[index].class = 'active'
                    EUY.SetStorage('tabs', tabs_store)
                    this.tabs = tabs_store;
                    EUY.SetStorage("currentTab", tabs_store[index]);
                    console.log("changeTab", tabs_store[index])
                    this.$router.push(tabs_store[index].url)
                    setTimeout(() => {
                        this.handleTabStatus(tabs_store[index]);
                        this.handleProtoBuf_1_12(tabs_store[index]);
                    }, 200)
                }
            },

            closeTab(id) {
                this.tabs_status = 'init'
                let tabs_store = EUY.GetStorage('tabs');
                let tab = EUY.GetStorage("currentTab");
                let tabs_current_id = tab.id;
                if (tabs_store) {
                    let index = 0
                    for (let i = 0; i < tabs_store.length; i++) {
                        tabs_store[i].class = ''
                        if (tabs_store[i].id == id) {
                            index = i
                        }
                    }
                    if(index > 0) {
                        if (tabs_current_id != id) {
                            tabs_store.splice(index, 1)
                            if (tabs_store.length == 1) {
                                this.$router.push('/homepage')
                            }
                            for (let i = 0; i < tabs_store.length; i++) {
                                if (tabs_store[i].id == tabs_current_id) {
                                    tabs_store[i].class = 'active'
                                }
                            }
                            EUY.SetStorage('tabs', tabs_store)
                            this.tabs = tabs_store
                        } else {
                            tabs_store[index - 1].class = 'active';
                            EUY.SetStorage('currentTab', tabs_store[index - 1]);
                            tabs_store.splice(index, 1)
                            EUY.SetStorage('tabs', tabs_store)
                            this.tabs = tabs_store
                            this.$router.push(tabs_store[index - 1].url)

                            setTimeout(() => {
                                this.handleTabStatus(tabs_store[index - 1]);
                                this.handleProtoBuf_1_12(tabs_store[index-1]);
                            }, 200)
                        }
                    }
                }
            },

            handleProtoBuf_1_12(tab)
            {
                let params = {
                    setType: tab.tab_type,
                    setTitle: tab.title,
                    setId: tab.id,
                    setScreentype: tab.proportion,
                    setTeamid: tab.team_id,
                    setTeamname: tab.team_name,
                    setFolder: tab.folder,
                    setData: tab.data
                }
                console.log("handleProtoBuf_1_12", params)
                let core_all_1_12 = {
                    packageId: 0,
                    senderId: CORE,
                    senderName: CORE_NAME,
                    receiverId: ALL,
                    receiverName: ALL_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: MESSAGE_ID_CORE_ALL_1_12,
                    protoBytesType: 'proto.com.proto.s.MTabData',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MTabData(), params)
                }
                // 发送消息
                Protocol.sender("h5", core_all_1_12)
            },

            handleTabStatus(tabData)
            {
                let tab_type = tabData.tab_type;
                let tab_data = tabData.data;
                let platform = this.$route.query.platform
                let timeline_toolbar = $('.timeline_toolbar')
                let action_timeline = $('.action-timeline-container')
                let editor_timeline = $('.editor-timeline-container')
                let template = $('.template-container')
                let scene = $('.scene-container')
                let panel_right = $('#PANELRIGHT-SWF')
                let tabs = $('#PANELRIGHT-SWF > .tabs-panel > .item')
                let panels = $('#PANELRIGHT-SWF > .panel-group > .panel')
                let t = $('#PANELRIGHT-SWF > .title')
                $('.timeline_toolbar').hide()
                $('#ACTION-SWF').css({
                    left: 0,
                    width: 280,
                    borderLeft: 'none',
                    borderRight: 'none'
                })
                .parent().hide()
                .find('.mask').show
                $('.title_action').css({
                    left: 0,
                    width: 280,
                    borderLeft: 'none',
                    borderRight: 'none',
                    zIndex: -1
                })
                tabs.each(function (index) {
                    $(this).on('click', function() {
                        panel_right.css({ width: 280 })
                        scene.css({ right: 336 })
                        editor_timeline.css({ right: 336 })
                        action_timeline.css({ right: 336 })
                        $(this).addClass('active')
                        .siblings().removeClass('active')
                        panels.eq(index).show()
                        .siblings().hide()
                        if (index == 0) {
                            t.html('素材')
                        }else if (index == 1) {
                            t.html('动作')
                        }else if (index == 2) {
                            t.html('镜头')
                        }else if (index == 3) {
                            t.html('文字')
                        }else if (index == 4) {
                            t.html('声音')
                        }else if (index == 5) {
                            t.html('样式')
                        }else if (index == 6) {
                            t.html('属性')
                            let step_scene_6_2 = {
                                packageId: 0,
                                senderId: STEP,
                                senderName: STEP_NAME,
                                receiverId: SCENE,
                                receiverName: SCENE_NAME,
                                timeFlag: new Date().getTime(),
                                sessionId: 6,
                                messageId: MESSAGE_ID_STEP_SCENE_6_2,
                                protoBytesType: '',
                                protoBytes: []
                            }
                            Protocol.sender(platform, step_scene_6_2)
                        }else if (index == 7) {
                            t.html('设置')
                        }else if (index == 8) {
                            t.html('部件')
                        }
                    })
                })
                if (tab_type == 1) {
                    action_timeline.hide()
                    editor_timeline.show()
                    template.show()
                    scene.css({ left: 0, bottom: 78 })
                    editor_timeline.css({ left: 0 })
                    action_timeline.css({ left: 0 })
                    template.css({ width: 0 })
                    let templateBtn = $('.template-container > .btn')
                    if(templateBtn) {
                        templateBtn.css({ left: 0 })
                        if(templateBtn.get(0)) {
                            templateBtn.get(0).className = 'btn el-icon-arrow-right'
                        }
                    }
                    tabs.each(function (index) {
                        $(this).css({ position: 'relative', left: 0, pointerEvents:'auto', opacity: 1 })
                        if (index > 6) {
                            $(this).css({ position: 'absolute', left: 50 })
                        }
                    })
                }else if (tab_type == 2) {
                    editor_timeline.hide()
                    template.hide()
                    action_timeline.show()
                    scene.css({ left: 0, bottom: 96 })
                    action_timeline.css({ left: 0 })
                    tabs.each(function (index) {
                        $(this).css({ position: 'relative', left: 0, pointerEvents:'auto', opacity: 1 })
                        //动画中编辑动作素材面板不可用
                        if(tab_data != '' && index == 0) {
                            $(this).css({ pointerEvents:'none', opacity: 0.6 })
                        }
                        if (index > 0 && index < 7) {
                            $(this).css({ position: 'absolute', left: 50 })
                        }
                    })
                }else if(tab_type == 3) {
                    action_timeline.hide()
                    editor_timeline.hide()
                    template.hide()
                    scene.css({ left: 0, bottom: 0 })
                    tabs.each(function (index) {
                        $(this).css({ position: 'relative', left: 0, pointerEvents:'auto', opacity: 1 })
                        if (index != 0 && index != 1 && index != 5 && index != 6) {
                            $(this).css({ position: 'absolute', left: 50 })
                        }
                    })
                }else if (tab_type == 4) {
                    action_timeline.hide()
                    editor_timeline.hide()
                    template.hide()
                    scene.css({ left: 0, bottom: 0 })
                    tabs.each(function (index) {
                        $(this).css({ position: 'relative', left: 0, pointerEvents:'auto', opacity: 1 })
                        if (index < 8) {
                            $(this).css({ position: 'absolute', left: 50 })
                        }
                    })
                }
            },

            // 动作编辑模式进出：切换底部时间轴与右侧面板布局
            // 进入 = tab_type==2 布局（动作时间轴 + 部件/设置面板），退出 = 还原动画编辑布局
            handleActionEditMode (entering, info) {
                let action_timeline = $('.action-timeline-container')
                let editor_timeline = $('.editor-timeline-container')
                let template = $('.template-container')
                let scene = $('.scene-container')
                let tabs = $('#PANELRIGHT-SWF > .tabs-panel > .item')
                let panels = $('#PANELRIGHT-SWF > .panel-group > .panel')
                let panel_right = $('#PANELRIGHT-SWF')
                let t = $('#PANELRIGHT-SWF > .title')
                if (entering) {
                    this.action_edit_mode = true
                    // 记录进入前打开的面板，退出动作编辑时恢复（对齐AS3退出动作编辑回动画编辑布局）
                    let activeTab = tabs.filter('.active')
                    let prevIndex = activeTab.length ? tabs.index(activeTab) : -1
                    this._preActionPanel = (prevIndex >= 0 && prevIndex <= 6)
                        ? { index: prevIndex, title: t.html() }
                        : null
                    editor_timeline.hide()
                    template.hide()
                    action_timeline.show()
                    // 动画编辑器的步编辑浮条也随步时间轴一起隐藏（不随布局自动回来）
                    $('.timeline_toolbar').hide()
                    scene.css({ left: 0, bottom: 96 })
                    action_timeline.css({ left: 0 })
                    tabs.each(function (index) {
                        $(this).css({ position: 'relative', left: 0, pointerEvents: 'auto', opacity: 1 })
                        // 动作编辑下素材面板不可用
                        if (index == 0) {
                            $(this).css({ pointerEvents: 'none', opacity: 0.6 })
                        }
                        if (index > 0 && index < 7) {
                            $(this).css({ position: 'absolute', left: 50 })
                        }
                    })
                    // 自动打开部件面板
                    panel_right.css({ width: 280 })
                    scene.css({ right: 336 })
                    action_timeline.css({ right: 336 })
                    tabs.removeClass('active').eq(8).addClass('active')
                    panels.hide().eq(8).show()
                    t.html('部件')
                    $(window).trigger('panelright.open')
                } else {
                    this.action_edit_mode = false
                    action_timeline.hide()
                    editor_timeline.show()
                    template.show()
                    //页面板若处于展开态(width=160)，画布/步时间轴左侧要同步让位，否则被面板遮盖
                    let pagePanelLeft = template.width()
                    scene.css({ left: pagePanelLeft, bottom: 78, right: 50 })
                    editor_timeline.css({ left: pagePanelLeft })
                    action_timeline.css({ left: pagePanelLeft })
                    tabs.each(function (index) {
                        $(this).css({ position: 'relative', left: 0, pointerEvents: 'auto', opacity: 1 })
                        if (index > 6) {
                            $(this).css({ position: 'absolute', left: 50 })
                        }
                    })
                    $('.timeline_toolbar').hide()
                    // 恢复进入动作编辑前打开的面板；此前未打开则收起面板
                    let prevPanel = this._preActionPanel
                    if (prevPanel) {
                        tabs.removeClass('active').eq(prevPanel.index).addClass('active')
                        panels.hide().eq(prevPanel.index).show()
                        t.html(prevPanel.title)
                        panel_right.css({ width: 280 })
                        scene.css({ right: 336 })
                        editor_timeline.css({ right: 336 })
                        $(window).trigger('panelright.open')
                    } else {
                        tabs.removeClass('active')
                        panels.hide()
                        t.html('')
                        panel_right.css({ width: 0 })
                    }
                    this._preActionPanel = null
                }
                // 通知时间轴组件重算尺寸
                setTimeout(() => {
                    $(window).trigger('resize')
                }, 50)
            },

            toolbarOpe (item) {
                let tab_type = this.Storage.get('currentTab').tab_type;
                if (this.action_edit_mode) tab_type = 2
                if (tab_type == 1) {

                    let platform = this.$route.query.platform
                    let id = item[0]

                    let MTimelineToolbarBack  = new proto.com.proto.s.MTimelineToolbarBack()
                    MTimelineToolbarBack.setId(id+'')
                    // protobuf 序列化
                    let protoBytes = MTimelineToolbarBack.serializeBinary()
                    // Uint8Array 转换 Array
                    let protoBytesArray = Array.from(protoBytes)
                    let core_timeline_1_8 = {
                        packageId: 0,
                        senderId: CORE,
                        senderName: CORE_NAME,
                        receiverId: TIMELINE,
                        receiverName: TIMELINE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 1,
                        messageId: MESSAGE_ID_CORE_TIMELINE_1_8,
                        protoBytesType: 'proto.com.proto.s.MTimelineToolbarBack',
                        protoBytes: protoBytesArray
                    }
                    // 发送消息
                    Protocol.sender(platform, core_timeline_1_8)
                }else if (tab_type == 2) {
                    let platform = this.$route.query.platform
                    let id = item[0]
                    let MTimelineToolbarBack  = new proto.com.proto.s.MTimelineToolbarBack()
                    MTimelineToolbarBack.setId(id+'')
                    // protobuf 序列化
                    let protoBytes = MTimelineToolbarBack.serializeBinary()
                    // Uint8Array 转换 Array
                    let protoBytesArray = Array.from(protoBytes)
                    let core_timeline_1_8 = {
                        packageId: 0,
                        senderId: CORE,
                        senderName: CORE_NAME,
                        receiverId: ACTIONTIMELINE,
                        receiverName: ACTIONTIMELINE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 1,
                        messageId: MESSAGE_ID_CORE_TIMELINE_1_8,
                        protoBytesType: 'proto.com.proto.s.MTimelineToolbarBack',
                        protoBytes: protoBytesArray
                    }
                    // 发送消息
                    Protocol.sender(platform, core_timeline_1_8)
                }
            },
            // 分享页隐藏 Tab
            handleShareHide ()
            {
                let path = this.$route.path
                if (path == '/share') {
                    this.tab_visible = false
                }
            },
            // ------------------------------------------------- [ API ] -------------------------------------------------
            // 获取 token 与用户信息
            handleGetUserInfo ()
            {
                clearInterval(this.token_heart_timer)
                // 心跳
                let _this = this
                let URL = process.env.HOST + '/api/a2/passport/heartbeat'
                let token = EUY.GetStorage('login_status').tokenId
                let exkey = EUY.GetStorage('login_status').exkey
                if(token == undefined || !token){
                    EUY.RemoveStorage('share')
                    EUY.RemoveStorage('editor_url')
                    EUY.RemoveStorage('login_status')
                    EUY.RemoveStorage('tabs')
                    EUY.RemoveStorage('currentTab')
                    EUY.RemoveStorage('team_info')
                    EUY.RemoveStorage('userinfo')
                    EUY.RemoveStorage('login_account')
                    location = '/login';
                    console.log("没有token 重新登录");
                    return
                }

                let params = 'tokenId=' + token
                let headers = {
                    'token': token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
                // console.log('---------- 0' + URL + JSON.stringify(params) + JSON.stringify(headers))
                this.AJAX.post(URL, headers, params).then((data)=>{
                    // console.log('---------- handleGetUserInfo => app' + JSON.stringify(data))
                    if(data.code == '0'){
                        _this.userinfo = {
                                        'nickname': data.result.baseInfo.nickname,
                                        'avatarInfo':data.result.avatarInfo.small,
                                        'gid': data.result.baseInfo.gid,
                                    }
                        EUY.SetStorage('userinfo', this.userinfo)
                        _this.login_status = {
                                        'tokenId': data.result.tokenId,
                                        'exkey': exkey,
                                        'oid': data.result.oid,
                                    }
                        EUY.SetStorage('login_status',_this.login_status)
                        _this.heart_reconnect_count = 0
                        let token_heart_time = 1000 * 60 * 7
                        this.token_heart_timer = setInterval(() =>{
                            _this.handleGetUserInfo()
                        },token_heart_time)
                    }else{
                        setTimeout(() => {
                            _this.handleGetUserInfo()
                        }, 5000);
                    }
                }).catch((err)=>{
                    // console.log('token心跳失败 ==> ' + JSON.stringify(err))
                    if(err.code == '20007'){
                        let exkey = EUY.GetStorage('login_status').exkey
                        if(exkey){
                            // 请求新的token
                            let URL = process.env.HOST + '/passport/tokenId'
                            let params = 'platform=web' + '&id=com.eeeuy.pro' + '&version=v1.1' + '&channel=eeeuy.com'
                            let headers = {
                                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                            }
                            this.AJAX.post(URL, headers, params).then((data)=>{
                                if(data.code == '0'){
                                    // exkey自动登录
                                    let url = process.env.HOST + '/passport/exkey'
                                    // 需要将+转译
                                    exkey = exkey.replace(/\+/g,'%2B')
                                    let param = 'tokenId=' + data.result.tokenId + '&exkey=' + exkey
                                    this.AJAX.post(url, headers, param).then((response)=>{
                                        if(response.code == '0'){
                                            _this.userinfo = {
                                                'nickname': response.result.baseInfo.nickname,
                                                'avatarInfo':response.result.avatarInfo.small,
                                                'gid': response.result.baseInfo.gid,
                                            }
                                            EUY.SetStorage('userinfo', _this.userinfo)
                                            _this.login_status = {
                                                                'tokenId': data.result.tokenId,
                                                                'exkey': response.result.exkey,
                                                                'oid': response.result.oid,
                                                                }
                                            EUY.SetStorage('login_status',_this.login_status)
                                        }
                                    }).catch((error)=>{
                                        if(response.code == undefined) {
                                            setTimeout(() => {
                                                _this.handleGetUserInfo()
                                            }, 5000);
                                        }else {
                                            EUY.RemoveStorage('share')
                                            EUY.RemoveStorage('editor_url')
                                            EUY.RemoveStorage('login_status')
                                            EUY.RemoveStorage('tabs')
                                            EUY.RemoveStorage('currentTab')
                                            EUY.RemoveStorage('team_info')
                                            EUY.RemoveStorage('userinfo')
                                            location = '/login';
                                            console.log("自动登陆失败 重新登录");
                                        }
                                    })
                                }
                            }).catch((err)=>{
                                setTimeout(() => {
                                    _this.handleGetUserInfo()
                                }, 5000);
                            })
                        }else{
                            // token失效，没有exkey 重新登录
                            EUY.RemoveStorage('share')
                            EUY.RemoveStorage('editor_url')
                            EUY.RemoveStorage('login_status')
                            EUY.RemoveStorage('tabs')
                            EUY.RemoveStorage('currentTab')
                            EUY.RemoveStorage('team_info')
                            EUY.RemoveStorage('userinfo')
                            location = '/login';
                            console.log("token失效，没有exkey 重新登录");
                        }
                    }
                })

                return
                // let _this = this
                $.ajax({
                    url:process.env.SSOHELLO,
                    dataType:'jsonp',
                    data:'',
                    async:false,
                    jsonp:'callback',
                    success:function(result) {
                        if(result.result){
                            _this.userinfo ={
                                'nickname': result.result.userInfo.nickname,
                                'avatarInfo':result.result.userInfo.avatarInfo.small,
                                'gid': result.result.userInfo.oid,
                            }
                            EUY.SetStorage('userinfo', _this.userinfo)
                            _this.login_status = {
                                'tokenId': result.result.tokenId,
                                'exkey': result.result.exkey,
                                'oid': result.result.userInfo.oid
                            }
                            EUY.SetStorage('login_status', _this.login_status)
                            if(result.result.sso){
                                for(var i=0;i<result.result.sso.length;i++){

                                    $.ajax({
                                        url:result.result.sso[i],
                                        dataType:'jsonp',
                                        data:'',
                                        jsonp:'callback',
                                        success:function(result) {
                                        }
                                    })
                                }
                            }
                        }else{
                            location = '/login';
                        }
                    },
                    error: function(err) {
                        console.log('error: function()' + JSON.stringify(err))
                        location = '/login';
                    }
                })
            },

            getShareUrl(code) {
                return "http://" + window.location.host + "/share?code=" + code;
            },

            getShare() {
                // storage-service(Java)接口，对齐老版PHP /pro/api/anim/getShare
                let url = "/api/storage/storage/share/getShare";
                let headers = {
                    'Authorization': EUY.GetStorage('login_status').tokenId
                }
                let params = {
                    'id': this.share_id
                }
                this.AJAX.get(url, headers, params).then((data)=> {
                    this.share_state = data.datas.status;
                    this.share_deadline = data.datas.expiryDate;
                    this.share_url = this.getShareUrl(data.datas.shareUrl);
                    if(this.share_state == 0 || this.share_state == 2) {
                        // this.createQRCode();
                        this.share_show_start = true;
                        this.share_show_stop = false;
                    }else if(this.share_state == 1) {
                        this.share_show_start = false;
                        this.share_show_stop = true;
                    }
                }).catch((err)=> {
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
            },

            createQRCode() {
                let qrimage = document.getElementById("qrcode");
                if(qrimage) {
                    let url = "http://h5.eeeuy.com/";
                    if(this.share_orientation == "landscape") {
                        url += "/player/?id=" + this.share_id + "&title=" + this.share_title;
                    }else {
                        url += "/portrait/?id=" + this.share_id + "&title=" + this.share_title;
                    }
                    url = encodeURI(url);
                    if(this.qrcode) {
                        this.qrcode.clear();
                        this.qrcode.makeCode(url);
                    }else {
                        this.qrcode = new QRCode(qrimage, {
                            text: url,
                            width: 80,
                            height: 80
                        });
                    }
                }
            },

            startShare() {
                // storage-service(Java)接口，对齐老版PHP /pro/api/anim/startShare
                let url = "/api/storage/storage/share/startShare";
                let headers = {
                    'Authorization': EUY.GetStorage('login_status').tokenId,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                }
                let params = 'id=' + this.share_id + '&limittime=' + this.share_select_time;
                console.log(params)
                this.AJAX.post(url, headers, params).then((data)=> {
                    this.share_state = data.datas.status;
                    this.share_deadline = data.datas.expiryDate;
                    this.share_url = this.getShareUrl(data.datas.shareUrl);
                    if(this.share_state == 0 || this.share_state == 2) {
                        this.share_show_start = true;
                        this.share_show_stop = false;
                    }else if(this.share_state == 1) {
                        this.share_show_start = false;
                        this.share_show_stop = true;
                    }
                }).catch((err)=> {
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
            },

            stopShare() {
                // storage-service(Java)接口，对齐老版PHP /pro/api/anim/stopShare
                let url = "/api/storage/storage/share/stopShare";
                let headers = {
                    'Authorization': EUY.GetStorage('login_status').tokenId,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                }
                let params = 'id=' + this.share_id;
                this.AJAX.post(url, headers, params).then((data)=> {
                    if(data.datas == true) {
                        this.share_state = 0;
                        this.share_show_start = false;
                        this.share_show_stop = false;
                    }else {
                        alert("关闭失败")
                    }
                }).catch((err)=> {
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
            },

            handleStartShare() {
                this.share_show_start = false;
                this.share_show_stop = false;
                this.startShare();
            },

            handleStopShare() {
                this.share_show_start = false;
                this.share_show_stop = false;
                this.stopShare();
            },

            handleShareCopy() {
                var clipboard = new Clipboard('#copy_btn');
                document.getElementById('clipboard').innerHTML = this.share_url;
            },

            handleTextBox() {
                let platform = this.$route.query.platform;
                let backData  = new proto.com.proto.s.MTextBoxBack();
                backData.setId(this.text_box_data.id);
                backData.setValue(this.text_box_data.value);
                console.log(backData);
                // protobuf 序列化
                let protoBytes = backData.serializeBinary()
                // Uint8Array 转换 Array
                let protoBytesArray = Array.from(protoBytes)
                let core_timeline_1_29 = {
                    packageId: 0,
                    senderId: CORE,
                    senderName: CORE_NAME,
                    receiverId: SCENE + HOMEPAGE,
                    receiverName: '',
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: MESSAGE_ID_CORE_TIMELINE_1_29,
                    protoBytesType: 'proto.com.proto.s.MTextBoxBack',
                    protoBytes: protoBytesArray
                }
                // 发送消息
                Protocol.sender(platform, core_timeline_1_29)
                this.text_box_show = false;
            },
            //鼠标是否在SWF上
            isOverSwf(mEvent)
            {
                var elem;
                if (mEvent.srcElement) {
                    elem = mEvent.srcElement;
                } else if (mEvent.target) {
                    elem = mEvent.target;
                }
                if (elem.nodeName.toLowerCase() == "object" || elem.nodeName.toLowerCase() == "embed") {
                    if (elem.getAttribute("classid") == "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000") {
                        return true;
                    }
                    if (elem.getAttribute("type") == "application/x-shockwave-flash") {
                        return true;
                    }
                }
                return false;
            },
            isScene(mEvent)
            {
                var elem;
                if (mEvent.srcElement) {
                    elem = mEvent.srcElement;
                } else if (mEvent.target) {
                    elem = mEvent.target;
                }
                //console.log(elem.getAttribute("id"))
                if(elem.getAttribute("id") == 'SCENE-SWF'){
                    return true;
                }
                return false;
            },
            mousewheelPage(e) {
                let event = e ? e : window.event;
                if(this.isOverSwf(event) && this.isScene(event)) {
                    if(event.wheelDelta){
                        console.log('mousewheelPage', event.wheelDelta);
                        if(!this.mouseWheelWaiting) {
                            setTimeout(() =>{
                                this.mouseWheelWaiting = false;
                            }, 8)
                            this.mouseWheelWaiting = true;
                            let delta = Math.floor(event.wheelDelta / 40);
                            //这里发消息
                            let platform = this.$route.query.platform;
                            let backData  = new proto.com.proto.s.MInt32;
                            backData.setValue(delta);
                            console.log(backData);
                            // protobuf 序列化
                            let protoBytes = backData.serializeBinary();
                            // Uint8Array 转换 Array
                            let protoBytesArray = Array.from(protoBytes);
                            let core_mouseWheel_1_31 = {
                                packageId: 0,
                                senderId: CORE,
                                senderName: CORE_NAME,
                                receiverId: SCENE + ACTIONTIMELINE,
                                receiverName: SCENE_NAME,
                                timeFlag: new Date().getTime(),
                                sessionId: 1,
                                messageId: MESSAGE_ID_CORE_MOUSEWHEEL_1_31,
                                protoBytesType: 'proto.com.proto.s.MInt32',
                                protoBytes: protoBytesArray
                            }
                            Protocol.sender(platform, core_mouseWheel_1_31)
                            //
                        }
                        event.preventDefault();
                        event.returnValue = false;
                    }
                }

            },
            goBack(){
                // this.$router.replace({path: '/'});
                console.log('goBack ===== > 0')
                this.handleCloseTab(this.tabs.length-1);
                this.pop_block_show = false
            },
        },

        // 渲染
        mounted ()
        {
            // document.addEventListener('keydown', function(e) {
            //     if((e.keyCode == 83 && e.ctrlKey) ||
            //         (e.keyCode == 83 && e.metaKey)) { //禁掉保存快捷键
            //         e.preventDefault();
            //         return false;
            //     }
            // }, false);
            // document.addEventListener('keydown',function(e){}, false);
            //滚轮侦听
            window.onmousewheel = document.onmousewheel = this.mousewheelPage
            // 点击步时间轴/动作时间轴面板其它区域时隐藏时间轴控制浮层(.timeline_toolbar)
            $(document).on('mousedown.timeline_toolbar_hide', function (e) {
                let tb = $('.timeline_toolbar')
                if (!tb.is(':visible')) return
                if ($(e.target).closest('.timeline_toolbar').length) return
                if ($(e.target).closest('.editor-timeline-container, .action-timeline-container').length) {
                    tb.hide()
                }
            })
            let component = this
            // 监听浏览器的返回事件
            if(window.history && window.history.pushState){
                history.pushState(null, null, '');//document.URL
                window.addEventListener('popstate', function () {
                    // history.pushState(null, null, '');
                    // let tabs_store = EUY.GetStorage('tabs')
                    //  console.log('浏览器的返回事件 0=====> ' + JSON.stringify(tabs_store))
                    // component.handleCloseTab(tabs_store.length-1);
                    // component.pop_block_show = false
                });
                // console.log('浏览器的返回事件 1=====> ' )
            }

            // 多人限制打开动画 -> 心跳保持 心跳间隔30s
            let heartbeat_time = 30000
            this.timer_anim_heartbeat = setInterval(() => {
                this.handleAnimHeartbeat()
            },heartbeat_time)

            let width = document.body.clientWidth
            let height = document.body.clientHeight
            $('.export').css({
                width: width + 'px',
                height: height + 'px'
            })
            // 分享页隐藏 Tab
            this.handleShareHide()
            // 页面初始化--储存信息
            // 获取版本
            let platform = this.$route.query.platform
            let _this = this
            let timer = null
            if(platform != 'qt'){
                // CORE
                // 模块初始化
                Protocol.onSocketInit(platform, CORE_NAME, CORE)
                // 模块与服务器建立链接
                Protocol.onSocketConnect(platform, CORE_NAME)
                // 模块与服务器建立链接
                Protocol.onSocketRegister(platform, CORE_NAME, CORE)
                // 接收消息 => CORE
                Protocol.receiver(platform, CORE_NAME)
                // 获取 token 与用户信息
                if (this.$route.path != '/share' && this.$route.path != '/login') {
                    _this.handleGetUserInfo()
                }
                window[CORE_NAME].message = function (senderId, packageId, sessionId, messageId, protoBytes)
                {
                    // 引擎动作编辑模式进出通知（MString 承载 JSON；双击形象进入动作编辑）
                    if (sessionId == 60 && (messageId == 62 || messageId == 63)) {
                        let info = {}
                        try {
                            info = JSON.parse(Protocol.deserializeBinary('proto.com.proto.s.MString', protoBytes).getValue() || '{}')
                        } catch (e) {}
                        _this.handleActionEditMode(messageId == 62, info)
                        return
                    }
                    //请求用户数据
                    if (sessionId == 1 && messageId == 3) {
                        // protobuf 打包
                        let UserInfo  = new proto.com.proto.s.UserInfo()
                        let BaseInfo = new proto.com.proto.s.BaseInfo()
                        let AvatarInfo = new proto.com.proto.s.AvatarInfo()
                        UserInfo.setBaseinfo(BaseInfo)
                        UserInfo.setAvatarinfo(AvatarInfo)
                        // protobuf 打包格式
                        BaseInfo.setGid(EUY.GetStorage('userinfo').gid)
                        BaseInfo.setNickname(EUY.GetStorage('userinfo').nickname)
                        AvatarInfo.setMiddle(EUY.GetStorage('userinfo').avatarInfo)
                        // protobuf 序列化
                        let protoBytes = UserInfo.serializeBinary()
                        // Uint8Array 转换 Array
                        let protoBytesArray = Array.from(protoBytes)
                        let core_homepage_1_4 = {
                            packageId: 0,
                            senderId: CORE,
                            senderName: CORE_NAME,
                            receiverId: senderId,
                            receiverName: HOMEPAGE_NAME,
                            timeFlag: new Date().getTime(),
                            sessionId: 1,
                            messageId: MESSAGE_ID_CORE_HOMEPAGE_1_4,
                            protoBytesType: 'proto.com.proto.s.UserInfo',
                            protoBytes: protoBytesArray
                        }
                        // 发送消息
                        Protocol.sender(platform, core_homepage_1_4)
                    }else if (sessionId == 1 && messageId == MESSAGE_ID_HOMEPAGE_CORE_1_5) { //模块通知Core切换标签页，并提供标签页数据
                        //接收homepage_core_1_5消息
                        _this.tabs_status = 'create'
                        let tab = Protocol.deserializeBinary('proto.com.proto.s.MTabData', protoBytes).toObject();
                        let core_scene_1_22 = {
                            packageId: 0,
                            senderId: CORE,
                            senderName: CORE_NAME,
                            receiverId: SCENE,
                            receiverName: SCENE_NAME,
                            timeFlag: new Date().getTime(),
                            sessionId: 1,
                            messageId: MESSAGE_ID_CORE_SCENE_1_22,
                            protoBytesType: 'proto.com.proto.s.MString',
                            protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MString(), {
                                setValue: tab.id,
                            })
                        }
                        _this.createTab(tab)
                        // 发送消息
                        Protocol.sender(platform, core_scene_1_22)
                    }else if (sessionId == 1 && messageId == 9) {
                        console.log('1_9 ================================>')
                        _this.sender = senderId
                        _this.alertData = Protocol.deserializeBinary('proto.com.proto.s.MAlert', protoBytes).toObject()
                        console.log(_this.alertData)
                        _this.dialog_create_action_visible = true
                    }else if (sessionId == 1 && messageId == 11) { //请求当前tab数据
                        console.log('1_11 ================================>请求TAB数据')
                        let tabs_info = EUY.GetStorage('currentTab');
                        if (tabs_info) {
                            let core_all_1_12 = {
                                packageId: 0,
                                senderId: CORE,
                                senderName: CORE_NAME,
                                receiverId: senderId,
                                receiverName: senderId,
                                timeFlag: new Date().getTime(),
                                sessionId: 1,
                                messageId: MESSAGE_ID_CORE_ALL_1_12,
                                protoBytesType: 'proto.com.proto.s.MTabData',
                                protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MTabData(), {
                                    setType: tabs_info.tab_type,
                                    setTitle: tabs_info.title,
                                    setId: tabs_info.id,
                                    setScreentype: tabs_info.proportion,
                                    setTeamid: tabs_info.team_id,
                                    setTeamname: tabs_info.team_name,
                                    setFolder: tabs_info.folder,
                                    setData:tabs_info.data
                                })
                            }
                            // 发送消息
                            Protocol.sender(platform, core_all_1_12)
                            console.log('1_11 ============>请求TAB数据，成功')
                        } else {
                            console.log('1_11 ============>请求TAB数据，失败')
                        }
                    }else if (sessionId == 1 && messageId == 6) { //显示时间轴控制条
                        let tab_type = EUY.GetStorage('currentTab').tab_type;
                        if (_this.action_edit_mode) tab_type = 2;
                        let timelineToolbar = Protocol.deserializeBinary('proto.com.proto.s.MTimelineToolbar', protoBytes).array
                        _this.toolbar_list = []
                        _this.timeline_position_left = timelineToolbar[0]
                        _this.toolbar_list = timelineToolbar[2]
                        if (tab_type == 1) {
                            let top  = $('.editor-timeline').offset().top - 40 + 'px'
                            let left = $('.editor-timeline').offset().left + timelineToolbar[0] - 20 + 'px'
                            $('.timeline_toolbar').show()
                            $('.timeline_toolbar').css({
                                top: top,
                                left: left
                            })
                        }else if (tab_type == 2) {
                            let top_ = 0
                            if(!timelineToolbar[1]){
                                top_ = 0
                            }else{
                                top_ = timelineToolbar[1]
                            }
                            let top  = $('.action-timeline').offset().top - 50 + top_ + 'px'
                            let left = $('.action-timeline').offset().left + timelineToolbar[0] - 18+ 'px'
                            $('.timeline_toolbar').show()
                            $('.timeline_toolbar').css({
                                top: top,
                                left: left
                            })
                        }
                    }else if (sessionId == 1 && messageId == 7) { // 隐藏时间轴控制条
                        $('.timeline_toolbar').hide()
                    }else if(sessionId == 1 && messageId == 1){ //请求Token
                        let core_material_1_2 = {
                            packageId: 0,
                            senderId: CORE,
                            senderName: CORE_NAME,
                            receiverId: senderId,
                            receiverName: '',
                            timeFlag: new Date().getTime(),
                            sessionId: 1,
                            messageId: MESSAGE_ID_CORE_MATERIAL_1_2,
                            protoBytesType: 'proto.com.proto.s.MToken',
                            protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MToken(), {
                                setToken: EUY.GetStorage('login_status').tokenId
                            })
                        }
                        Protocol.sender(platform, core_material_1_2)
                    }else if (sessionId == 1 && messageId == 15) { // 更新tab数据
                        let tabdata = Protocol.deserializeBinary('proto.com.proto.s.MTabData', protoBytes).toObject();
                        let tabs = EUY.GetStorage('tabs');
                        if(null != tabs && Array.isArray(tabs)) {
                            for(let i = 0;i < tabs.length; i++) {
                                if(tabs[i].id == tabdata.id) {
                                    tabs[i].title = tabdata.title;
                                    _this.tabs = tabs;
                                    EUY.SetStorage('tabs',tabs);
                                    break;
                                }
                            }
                        }
                    }else if (sessionId == 1 && messageId == 19) {
                        let mu32 = Protocol.deserializeBinary('proto.com.proto.s.MUint32', protoBytes)
                        //jspb MUint32只有value单值字段（.array为AS3遗留恒undefined），统一成数组
                        let arr = mu32 ? (mu32.array || (mu32.getValue !== undefined ? [mu32.getValue()] : [])) : []
                        if (arr[0] == MATERIAL) {
                            open_panel('素材', 0)
                        }else if (arr[0] == ACTION) {
                            open_panel('动作', 1)
                        }else if (arr[0] == CAMERA) {
                            open_panel('镜头', 2)
                        }else if (arr[0] == TEXT) {
                            open_panel('文字', 3)
                        }else if(arr[0] == ALIGN) {
                            open_panel('样式', 5)
                        }else if (arr[0]  == PARTS) {
                            open_panel('部件', 8)
                        }else if (arr[0]  == PAGE) {
                            let action_timeline = $('.action-timeline-container')
                            let editor_timeline = $('.editor-timeline-container')
                            let template = $('.template-container')
                            let template_btn = $('.template-container > .btn')
                            let scene = $('.scene-container')
                            template.css({ width: 160 })
                            template_btn.css({ left: 160 })
                            editor_timeline.css({ left: 160 })
                            action_timeline.css({ left: 160 })
                            scene.css({ left: 160 })
                            template_btn.get(0).className = 'btn el-icon-arrow-left'
                            _this.pop_block_left = 160
                        }else if (arr[0] == EXPORT){
                            _this.export_status = true
                        }
                        function open_panel(title, index) {
                            let action_timeline = $('.action-timeline-container')
                            let editor_timeline = $('.editor-timeline-container')
                            let template = $('.template-container')
                            let scene = $('.scene-container')
                            let panel_right = $('#PANELRIGHT-SWF')
                            let tabs = $('#PANELRIGHT-SWF > .tabs-panel > .item')
                            let panels = $('#PANELRIGHT-SWF > .panel-group > .panel')
                            let t = $('#PANELRIGHT-SWF > .title')
                            tabs.removeClass('active').eq(index).addClass('active')
                            panels.hide().eq(index).show()
                            t.html(title)
                            panel_right.css({ width: 280 })
                            scene.css({ right: 336 })
                            editor_timeline.css({ right: 336 })
                            action_timeline.css({ right: 336 })
                            // 面板被折叠按钮合上时，同步复位right/folded（否则只留出空白、面板还在屏幕外）
                            $(window).trigger('panelright.open')
                        }

                        if(_this.action_info_modlus_status){
                            _this.action_info_modlus_status = false
                            let action_core_1_20 = {
                                packageId: 0,
                                senderId: CORE,
                                senderName: CORE_NAME,
                                receiverId: CORE,
                                receiverName: CORE_NAME,
                                timeFlag: new Date().getTime(),
                                sessionId: 1,
                                messageId: MESSAGE_ID_ACTION_CORE_1_20,
                                protoBytesType: "proto.com.proto.s.MUint32",
                                protoBytes: Protocol.serializeBinary(
                                    new proto.com.proto.s.MUint32(),
                                    {
                                        setValue: ACTION
                                    }
                                )
                            };
                            // 发送消息
                            Protocol.sender(platform, action_core_1_20);
                        }

                    }else if (sessionId == 1 && messageId == 20) {
                        let arr = Protocol.deserializeBinary('proto.com.proto.s.MUint32', protoBytes).array
                        _this.action_info_modlus_status = false
                        if (arr == 16) {
                            $('#ACTION-SWF').parent().css({
                                left: 0,
                                width: 280,
                                borderLeft: '0px solid #ccc',
                                borderRight: '0px solid #ccc',
                                display: 'none'
                            })
                            .find('.mask').hide()
                            $('.title_action').css({
                                left: 0,
                                width: 280,
                                borderLeft: '1px solid #ccc',
                                borderRight: '1px solid #ccc',
                                zIndex: -1
                            })
                        }
                        if(arr[0] == 524288){
                            _this.export_status = false
                        }

                        // 关闭动作面板需要将遮罩显示
                        let action_core_1_32 = {
                                packageId: 0,
                                senderId: CORE,
                                senderName: CORE_NAME,
                                receiverId: ACTION,
                                receiverName: ACTION_NAME,
                                timeFlag: new Date().getTime(),
                                sessionId: 1,
                                messageId: MESSAGE_ID_ACTION_CORE_1_32,
                                protoBytesType: "proto.com.proto.s.MBool",
                                protoBytes: Protocol.serializeBinary(
                                    new proto.com.proto.s.MBool(),
                                    {
                                        setValue: true
                                    }
                                )
                            };

                            // 发送消息
                        Protocol.sender(platform, action_core_1_32);
                    }else if (sessionId == 1 && messageId == 21) {
                        let arr = Protocol.deserializeBinary('proto.com.proto.s.MUint32', protoBytes).array
                        if (arr == 16) {
                            // $('#ACTION-SWF').parent().css({
                            //     left: -252,
                            //     width: 250,
                            //     borderLeft: '1px solid #ccc',
                            //     borderRight: '1px solid #ccc',
                            //     display: 'block'
                            // })
                            // .find('.mask').hide()
                            // $('.title_action').css({
                            //     left: -252,
                            //     width: 250,
                            //     borderLeft: '1px solid #ccc',
                            //     borderRight: '1px solid #ccc',
                            //     zIndex: 1
                            // })
                            // 打开面板
                            if(!_this.action_info_modlus_status){
                                _this.action_info_modlus_status = true
                                $('#ACTION-SWF').parent().css({
                                left: -282,
                                width: 280,
                                borderLeft: '0px solid #ccc',
                                borderRight: '0px solid #ccc',
                                display: 'block'
                            })
                                .find('.mask').hide()
                                $('.title_action').css({
                                    left: -282,
                                    width: 280,
                                    borderLeft: '1px solid #ccc',
                                    borderRight: '1px solid #ccc',
                                    zIndex: 1
                                })

                            // 打开动作面板需要将遮罩清除
                            let action_core_1_32 = {
                                    packageId: 0,
                                    senderId: CORE,
                                    senderName: CORE_NAME,
                                    receiverId: ACTION,
                                    receiverName: ACTION_NAME,
                                    timeFlag: new Date().getTime(),
                                    sessionId: 1,
                                    messageId: MESSAGE_ID_ACTION_CORE_1_32,
                                    protoBytesType: "proto.com.proto.s.MBool",
                                    protoBytes: Protocol.serializeBinary(
                                        new proto.com.proto.s.MBool(),
                                        {
                                            setValue: false
                                        }
                                    )
                                };

                                // 发送消息
                                Protocol.sender(platform, action_core_1_32);
                            }
                            // 关闭面板
                            else{
                                _this.action_info_modlus_status = false
                                let action_core_1_20 = {
                                    packageId: 0,
                                    senderId: CORE,
                                    senderName: CORE_NAME,
                                    receiverId: CORE,
                                    receiverName: CORE_NAME,
                                    timeFlag: new Date().getTime(),
                                    sessionId: 1,
                                    messageId: MESSAGE_ID_ACTION_CORE_1_20,
                                    protoBytesType: "proto.com.proto.s.MUint32",
                                    protoBytes: Protocol.serializeBinary(
                                        new proto.com.proto.s.MUint32(),
                                        {
                                            setValue: ACTION
                                        }
                                    )
                                };

                                // 发送消息
                                Protocol.sender(platform, action_core_1_20);
                            }
                        }
                    }else if (sessionId == 1 && messageId == 23) {
                        let arr = Protocol.deserializeBinary('proto.com.proto.s.MString', protoBytes).array
                        if (arr) {
                            clearInterval(_this.timer_create)
                            clearInterval(_this.timer_change)
                            clearInterval(_this.timer_close)
                        }
                    }else if (sessionId == 1 && messageId == 24) {
                        let arr = Protocol.deserializeBinary('proto.com.proto.s.MString', protoBytes).array
                        if (_this.tabs_status == 'create') {
                            clearInterval(_this.timer_create)
                            _this.changeTab(arr[0])
                        }
                        if (_this.tabs_status == 'change') {
                            clearInterval(_this.timer_change)
                            _this.changeTab(arr[0])
                        }
                        if (_this.tabs_status == 'close') {
                            clearInterval(_this.timer_close)
                            _this.closeTab(arr[0])
                        }
                    }else if (sessionId == 1 && messageId == 25) {
                        if (protoBytes) {
                            EUY.RemoveStorage('share')
                            EUY.RemoveStorage('editor_url')
                            EUY.RemoveStorage('login_status')
                            EUY.RemoveStorage('tabs')
                            EUY.RemoveStorage('currentTab')
                            EUY.RemoveStorage('team_info')
                            EUY.RemoveStorage('userinfo')
                            location = '/login'//process.env.LOGIN

                        }
                    }else if (sessionId == 7 && messageId == 8) {
                        let arr = Protocol.deserializeBinary('proto.com.proto.s.MFloat', protoBytes).array
                        let H = arr[0]
                        let scene = $('.scene-container')
                        let action_timeline = $('.action-timeline-container')
                        let action_timeline_swf = $('#ACTIONTIMELINE-SWF')
                        scene.css({ bottom: H })
                        action_timeline.css({ height: H })
                        action_timeline_swf.css({ height: H })
                    }else if (sessionId == 1 && messageId == 26) { //分享
                        let obj = Protocol.deserializeBinary('proto.com.proto.scene.MShareInfo', protoBytes).toObject();
                        _this.share_id = obj.id;
                        _this.share_title = obj.title;
                        _this.share_orientation = obj.orientation;
                        _this.getShare();
                    }else if(sessionId == 1 && messageId == 27) { //message
                        let obj = Protocol.deserializeBinary('proto.com.proto.s.MMessage', protoBytes).toObject();
                        let msgType = "info";
                        if(obj.type == 1) {
                            msgType = "success";
                        }else if(obj.type == 2) {
                            msgType = "warning";
                        }else if(obj.type == 3) {
                            msgType = "error";
                        }
                        _this.$message( {
                            message: obj.msg,
                            type: msgType
                        });
                    }else if(sessionId == 1 && messageId == 28) {
                        _this.text_box_data = Protocol.deserializeBinary('proto.com.proto.s.MTextBox', protoBytes).toObject();
                        _this.text_box_show = true;
                    }else if(sessionId == 1 && messageId == 30) { //back tab
                        // 动作编辑模式：返回键=退出动作编辑回动画编辑器（引擎侧按isEdited弹保存确认），不关闭动画标签
                        // 与ActionEditorTimeline"退"按钮走同一条60_61(scene.exitActionEdit)通路
                        if (_this.action_edit_mode) {
                            let engine = window.EuCoreEngine && window.EuCoreEngine.getInstance()
                            if (engine) {
                                engine.sendMessage({
                                    packageId: 0,
                                    senderId: CORE,
                                    senderName: 'CORE',
                                    receiverId: SCENE,
                                    receiverName: 'SCENE',
                                    timeFlag: new Date().getTime(),
                                    sessionId: 60,
                                    messageId: 61,
                                    protoBytes: [],
                                    data: { keepChanges: true }
                                })
                            }
                            return
                        }
                        // anim/endEdit
                        _this.handleAnimEndEdit()
                        _this.handleCloseTab(_this.tabs.length-1);
                        _this.pop_block_show = false
                    }else if (sessionId == 6 && messageId == 53) {
                        let frames = Protocol.deserializeBinary('proto.com.proto.scene.MShowFramesSetting', protoBytes).toObject()
                        console.log('MShowFramesSetting === > ' + JSON.stringify(frames))
                        if(frames){
                            _this.pop_block_originX = frames.offsetx
                            _this.pop_block_originY = frames.offsety
                            _this.rate_input_model = frames.setting.framerate
                            _this.duration_input_model = frames.setting.duration
                            _this.loop_data = frames.setting.loop?0:1
                            _this.pop_block_alias = frames.setting.alias
                            _this.pop_block_show = frames.isshow
                            _this.duration_input_disabled = frames.setting.loop? false:true
                        }

                    }else if (sessionId == 1 && messageId == 33) {
                        let arr = Protocol.deserializeBinary('proto.com.proto.s.MString', protoBytes).array
                        // console.log('sessionId == 1 && messageId == 33 === > ' + JSON.stringify(arr))
                        _this.pop_block_left = arr[0] == '0'?0:160
                        // if(arr[0] == '0'){
                        //     _this.pop_block_originX = 0
                        //     _this.pop_block_originY = 0
                        // }else{
                        //     _this.pop_block_originX = 100
                        //     _this.pop_block_originY = 200
                        // }

                    }
                }
                // TABS 初始化
                let tabs_store = EUY.GetStorage('tabs')
                if (tabs_store) {
                    _this.tabs = tabs_store
                } else {
                    let userinfo = EUY.GetStorage('userinfo')
                    if(userinfo){
                        _this.$router.push('/homepage')
                    }
                    // _this.$router.push('/homepage')
                    EUY.SetStorage('tabs', _this.tabs)

                }
                if (this.$route.path == '/homepage') {
                    let tabs_store = EUY.GetStorage('tabs')
                    for (let i = 0; i < tabs_store.length; i++) {
                        tabs_store[i].class = ''
                    }
                    tabs_store[0].class = 'active'
                    EUY.SetStorage('tabs', tabs_store)
                    this.tabs = tabs_store
                }
            }
        },
        watch: {
            // 'rate_input_model':function(){
            //     if(typeof this.rate_input_model == 'number'){
            //         this.rate_input_model = this.rate_input_model.toString()
            //     }
            //     this.rate_input_model = this.rate_input_model.replace(/[^\d]/g,'')
            //     if(this.rate_input_model >= 60){
            //         this.rate_input_model = '60'
            //     }
            // },

            'duration_input_model':function(){
                if(typeof this.duration_input_model == 'number'){
                    this.duration_input_model = this.duration_input_model.toString()
                }
                this.duration_input_model = this.duration_input_model.replace(/[^\.\d]/g,'')
            },

            $route(){
                let tabs_store = EUY.GetStorage('tabs')
                let currentIndex = 0;
                if (tabs_store) {
                    for (let i = 0; i < tabs_store.length; i++) {
                        tabs_store[i].class = ''
                        if (tabs_store[i].url == this.$route.path) {
                            currentIndex = i;
                            tabs_store[i].class = 'active'
                        }
                    }
                    console.log("roote changed::", this.$router, "  route  ", this.$route);
                    EUY.SetStorage('tabs', tabs_store)
                    EUY.SetStorage('currentTab', tabs_store[currentIndex]);
                    let temp = []
                    // 需要endEdit的id
                    if(tabs_store.length > 1 && currentIndex == 0){
                        this.pop_block_show = false
                        let heartId = tabs_store[currentIndex+1].id
                        for(let i = 0;i < tabs_store.length; i++){
                            if(i <= currentIndex){
                                temp.push(tabs_store[i])
                            }
                        }
                        tabs_store = temp
                        this.tabs = temp
                        EUY.SetStorage('tabs',temp);
                        // 动画id endEdit
                        let token = this.login_status.tokenId
                        // heartId 为homepage 或者以73开头 或者token为''都不心跳
                        if (heartId.substring(0, 2) == '73' || token == '' || heartId == 'homepage')return
                        let URL = process.env.HOST + '/api/storage/storage/resource/end-edit'
                        let params = 'id=' + heartId
                        let headers = {
                            'Authorization': token,
                            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                        }
                        this.AJAX.post(URL, headers, params, {noAuthRedirect: true}).then((data)=>{}).catch((err)=>{})
                    }

                    this.$router.push({path: this.$route.path, query: this.$route.query});
                    setTimeout(() => {
                        this.handleTabStatus(tabs_store[currentIndex].tab_type);
                        this.handleProtoBuf_1_12(tabs_store[currentIndex]);
                    }, 200);
                }
            }
        }
    }
</script>
<style lang="stylus">
  .core
    .tab
      background: #dbdbdb
      border: 1px solid #ccc
      height: 20px
      .active
        background: #eee
      div
        float: left
        border-bottom: 0
        padding: 0 10px
        height: 20px
        line-height: 20px
        font-size: 12px
        color: #797979
        border-left: 1px solid #ccc
        border-right: 1px solid #ccc
        margin-left: -1px
        cursor: pointer
        position: relative
        padding-right: 25px
        .el-icon-close
          width: 20px
          height: 20px
          line-height: 21px
          text-align: center
          position: absolute
          right: 0
          top: 0
          color: #616161
          &:hover
            color: #999
      div:first-child
        padding-right: 10px
        .el-icon-close
          display: none
      .router-link-active
        color: #585858
        background: #f0f0f0
    .timeline_toolbar
      height 40px
      background #eee
      position absolute
      display none
      border-radius 3px
      z-index: 10000
      pointer-events none
      .jiantou
        width 0px
        font-size: 0
        line-height: 0
        border-width: 10px
        border-color: #eeeeee
        border-bottom-width: 0
        border-style: dashed
        border-top-style: solid
        border-left-color: transparent
        border-right-color: transparent
        position absolute
        top 35px
        left 10px
      .item
        color #000
        float left
        width 40px
        text-align center
        height 40px
        line-height 40px
        cursor pointer
        padding-top 2px
        pointer-events auto
        i
          color #1E3255
          font-size 40px
          height 40px
          line-height 40px
          &:hover
            color #FF4F53
          &:active
            color #FF4F53
    .export
      position absolute
      top 0px
      left 0
      right 0
      bottom 0
    .dialog-delete
      .text
        line-height: 150%
        span
          color: #f00
    .pop_block
        position:absolute
        z-index:1000
        width:240px
        height:200px
        background:#fff
        box-shadow: 0 1px 3px rgba(0,0,0,.4)
        .top
         position:absolute;
         left:0;
         top:0;
         height:20px;
         right:0;
         background:white
         cursor:pointer
         .title
          position:absolute;
          left:0
          top:0
          bottom:0
          right:20px
          line-height:20px
          text-align:center
          font-size:12px
          background:#e8e8e8
         .close
          position:absolute;
          right:0
          top:0
          bottom:0
          width:20px
          line-height:20px
          text-align:center
          font-size:15px
          cursor:pointer
          background:#e8e8e8
        .content
          position:absolute;
          right:0
          top:45px
          bottom:0
          left:0
          background:#fff
          div
             font-size:10px
             color:#2f2f2f
             display:inline-block
          .rate
           position:absolute;
           left:16px
           top:12px
           right:50px
           height:15px
           .rate_input
            -webkit-transform:scale(0.9)
            width:60px
            height:10px
            font-size:30px
          .loop
            position:absolute;
            left:16px
            right:0
            height:15px
            top:50px
            // background:green
            .item
             margin-left:20px
            .el-radio__label {
                font-size: 12px
                color:#000
            }
            .el-radio__inner {
                width: 12px
                height: 12px
            }
          .duration
            position:absolute;
            left:16px
            right:0
            height:15px
            top:75px
            .duration_input
              background:#fff
              width:30px
              height:15px
              font-size:13px
            .disabled
              background:#c7c7c7
    #drag{
        width: 300px;
        height: 300px;
        position: absolute;
        top: 200px;
        left: 130px;
        border:2px solid #777;
        border-radius: 2px;
        background: red//#f3f3f3;
        }
</style>



// WEBPACK FOOTER //
// App.vue?2f26792e